import React from "react";
import $ from "jquery";
import { KeyboardEvent as ReactKeyboardEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Loader from "@/components/loader";
import Breadcrumb from "@/components/breadCrumb"
import SearchResult from "@/components/SearchAndResultShared/SearchResult"
import PaginationElementComponent from "@/components/PaginationElementComponent";
import { addViewportIsMobileListener, dnbComLog, isNotUndefined, isNotUndefinedOrNull, isUndefined, LogSeverity, trackGTMSearchSubmitEvents, trackNullSearchResults, trackSearchEvents } from "@/shared/FunctionCore";
import { useFocus, useDidUpdateEffect } from "@/shared/customHooks";
import { getContactSearchAPIData } from "@/services/contactDirectory";

// import {PaginationElementComponent} from "@/PaginationElementComponent/PaginationElementComponent";
// import { SearchHeading } from "@/components/SearchAndResultShared/SearchHeading";
import { contactProfilesCompanyFragmentParameterName, contactProfilesFullNameFragmentParameterName, contactProfilesJobTitleFragmentParameterName, getPageNumberFragmentParameterName, Tab, TabContentsComponent, TabContentsComponentProps } from "@/app/pages/businessDirectory/helpers";
import "@/app/pages/contactDirectory/styles/TabContactSearchStyles.scss";

export interface ISearchDataServletResponse {
	contacts: ISearchContact[];
	totalPages: number;
}
export interface ISearchContact {
	addressCountry: string;
	addressLocality: string;
	addressRegion: string;
	familyName: string;
	givenName: string;
	organizationName: string;
	title: string;
	url: string;
}

const isValidDuns = (companyInput: string) => window.Number.isInteger(window.Number(companyInput)) && companyInput.length === 9;
interface SubmitSearchValues {
	"company": string;
	"fullName": string;
	"jobTitle": string;
}

const TabContactSearch: TabContentsComponent = (props: TabContentsComponentProps) => {
	const {
		activeTab,
		isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage,
		isSearchOverlay,
		isSearchOverlayOpen,
		isSiteSearchResultsPage,
		manuallyTriggerNavigation,
		singlePageSearchData,
		useFragmentAndUrlState,
		useFragmentAndUrlStateTriggerNavigation,
		companyProfilesSearchValue,
		setCompanyProfilesSearchValue
	} = props;

	const {
		siteSearchResultsPathRewritten
	} = singlePageSearchData;

	const navigate = useNavigate();
	const { t } = useTranslation();
	const [focusReference, doFocus] = useFocus<HTMLInputElement>();
	const searchResultsContainerReference = useRef<HTMLDivElement>(null);
	const [searchInput, setSearchInput] = useState<string>("");
	const [contactSearchDataServletResponse, setContactSearchDataServletResponse] = useState<ISearchDataServletResponse | undefined>();
	const [fullName, setFullName] = useState("");
	const [isMobileWidth, setIsMobileWidth] = useState(false);
	const [jobTitle, setJobTitle] = useState("");
	const [loadingState, setLoadingState] = useState(false);
	const [scrollToSearchResultsContainer, setScrollToSearchResultsContainer] = useState(false);
	const [inputSearchCombineString, setInputSearchCombineString] = useState<string>("");

	const thisTab: Tab = "Contact Directory";

	const [companyValue, setCompanyValue] = useFragmentAndUrlStateTriggerNavigation(contactProfilesCompanyFragmentParameterName, "", false);
	const [fullNameValue, setFullNameValue] = useFragmentAndUrlStateTriggerNavigation(contactProfilesFullNameFragmentParameterName, "", false);
	const [jobTitleValue, setJobTitleValue] = useFragmentAndUrlStateTriggerNavigation(contactProfilesJobTitleFragmentParameterName, "", false);
	const [pageNumberString, setPageNumberString] = useFragmentAndUrlState(getPageNumberFragmentParameterName(thisTab), "1");

	const [pageNumber, setPageNumber] = [window.Number.parseInt(pageNumberString), (number: number) => setPageNumberString(number.toString())];

	const updateSubmitSearchValues = () => {
		setCompanyValue(searchInput);
		setFullNameValue(fullName);
		setJobTitleValue(jobTitle);

		manuallyTriggerNavigation();
	};

	const submitSearchValues: SubmitSearchValues | undefined =
		[fullNameValue, jobTitleValue, companyValue].some((st) => st.length > 0)
			? {
				"company": companyValue,
				"fullName": fullNameValue,
				"jobTitle": jobTitleValue,
			}
			: void 0;

	useEffect(() => {
		addViewportIsMobileListener((isMobile) => setIsMobileWidth(isMobile));
	}, []);

	useEffect(() => {
		if (isSearchOverlay && isSearchOverlayOpen && activeTab === thisTab) {
			doFocus();
		}
	}, [isSearchOverlay, isSearchOverlayOpen, activeTab]);

	useEffect(() => {
		if (isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab) {
			doFocus();
		}
	}, [activeTab, isSearchOverlay]);

	useDidUpdateEffect(() => {
		if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab) {
			doFocus();
		}
	}, [activeTab, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay]);

	useEffect(() => {
		setFullName(fullNameValue);
		setJobTitle(jobTitleValue);

		if (companyValue.length > 0) {
			setSearchInput(companyValue);
		}
	}, []);

	useEffect(() => {
		if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay) {
			if (isNotUndefined(submitSearchValues) && (submitSearchValues.fullName.length > 0 || submitSearchValues.jobTitle.length > 0 || submitSearchValues.company.length > 0)) {
				const submitSearchValuesCompany = submitSearchValues.company;
				const submitSearchValuesFullName = submitSearchValues.fullName;
				const submitSearchValuesJobTitle = submitSearchValues.jobTitle;

				const companyIsValidDuns = isValidDuns(submitSearchValuesCompany);

				const parameters = {
					"duns": companyIsValidDuns ? submitSearchValuesCompany : void 0,
					"fullname": submitSearchValuesFullName,
					"jobtitle": submitSearchValuesJobTitle,
					"pagenumber": pageNumber,
					"primaryname": companyIsValidDuns ? void 0 : submitSearchValuesCompany,
				};

				// Do not make network request if "page" is the only key with a corresponding value that is not undefined
				if (
					window.Object.entries(parameters)
						.map(([_, value]) => isNotUndefined(value))
						.filter(Boolean).length > 1
				) {
					setLoadingState(true);

					// axiosRetry(axios, {
					// 	"retries": 3,
					// 	"retryCondition": (error: AxiosError) => isUndefined(error.response) || error.response.status === 500,
					// });
					setInputSearchCombineString("")
					getSearchTermString()

					getContactSearchAPIData(parameters)
						.then((ax) => {
							setContactSearchDataServletResponse(ax.data);
							setLoadingState(false);

							if (scrollToSearchResultsContainer) {
								const current = searchResultsContainerReference.current;

								if (current !== null) {
									const $window = $(window);
									const position = $(current).offset()!.top - $window.height()! / 2
									$window.scrollTop(position);
									// $window.scrollTop($(current).offset()!.top - $window.height()! / 2);
								}

								setScrollToSearchResultsContainer(false);
							}

							if (ax.data.contacts.length === 0 && activeTab !== "All") {
								trackNullSearchResults();
							}
						}).catch((error) => {
							dnbComLog(LogSeverity.ERROR, error);
							setLoadingState(false)
						});
				}
			} else {
				setContactSearchDataServletResponse(void 0);
				setLoadingState(false);
				setPageNumber(1);
			}
		}
	}, [pageNumber, siteSearchResultsPathRewritten, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay, submitSearchValues?.fullName, submitSearchValues?.jobTitle, submitSearchValues?.company]);

	useEffect(() => {
		if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay && activeTab === thisTab && searchInput.length > 0) {
			setCompanyValue(searchInput);
		}
	}, [activeTab, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isSearchOverlay]);

	useDidUpdateEffect(() => {
		if (!isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage && !isSearchOverlay) {
			setPageNumber(1);
		}
	}, [submitSearchValues?.fullName, submitSearchValues?.jobTitle, submitSearchValues?.company]);

	const onKeyPress = (re: ReactKeyboardEvent<HTMLInputElement>) => {
		if (re.which === 13) { // enter key code is 13
			// updateSubmitSearchValues();
			onSearch();
			trackSearchEvents(activeTab, jobTitle);
		}
	};

	const haveInputData = () => {
		const inputFields = [searchInput, fullName, jobTitle, companyProfilesSearchValue]
		return inputFields.some((field: string) => field.length > 1)
	}

	const onSearch = () => {
		setCompanyProfilesSearchValue(searchInput);
		// resetInputs()

		if (haveInputData()) {
			if (isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage) {
				// true on BD landing page
				navigate(
					`/site-search-results.html#ContactProfilesCompany=${searchInput}&ContactProfilesFullName=${fullName}&ContactProfilesJobTitle=${jobTitle}&tab=Contact%20Directory`
				);
			} else {
				updateSubmitSearchValues()
				// getCompanySearchData();
			}
		}
	};

	const breadcrumbs = [
		{
			name: t("businessDirectory.SearchResultStartBreadcrumb"),
			url: "/"
		},
		{
			name: t("contactDirectory.contact_directory"),
			url: "/contact-directory.html",
		},
		{
			name: t("contactDirectory.contact_directory"),
			url: ""
		},
	];

	const renderPagination = () => (
		<PaginationElementComponent
			currentPage={pageNumber}
			currentPageValueClassName="currentPageValue"
			ellipsesClassName="ellipses"
			ltgtClassName="ltgt"
			nextButtonClassName="nextButton"
			nextClassName="next"
			onPageChange={(nu) => {
				setPageNumber(nu);
				setScrollToSearchResultsContainer(true);
			}}
			pageValueButtonClassName="pageValueButton"
			paginationContainerRef={void 0}
			previousButtonClassName="previousButton"
			previousClassName="previous"
			siblings={isMobileWidth ? 3 : 5}
			totalPages={contactSearchDataServletResponse?.totalPages ?? void 0}
			wrapperClassName="paginationWrapper"
		/>
	);

	const maxFullNameLength = 64;
	const maxCompanyNameLength = 30;
	const maxJobTitleLength = 30;

	const getSearchTermString = () => {
		let str = "";
		const transform = (text: string): string => `"${text}"`;

		if (companyValue !== "") {
			str = transform(companyValue)
		}
		if (fullNameValue !== "") {
			if (str !== '""' && str !== "") str = str + " and " + transform(fullNameValue)
			else str = transform(fullNameValue)
		}
		if (jobTitleValue !== "") {
			if (str !== "") str = str + " and " + transform(jobTitleValue)
			else str = transform(jobTitleValue)
		}

		setInputSearchCombineString(str)
	}

	return (
		<>
			<div className={isSearchOverlay || (isSiteSearchResultsPage && isUndefined(submitSearchValues)) ? "tabNameWrapper" : "tabNameWrapperWithoutBorderRadius"}>
				<div className="search-flex-wrapper">
					<div className="search-flex-container contactProfilesSearchFlexContainer">
						<div className="input-icon-container main-search-input">
							<span className="icon icon-person" />

							<input
								className="input-with-icon contact-search-input"
								maxLength={maxFullNameLength}
								onChange={(ch) => {
									setFullName(decodeURIComponent(ch.target.value));
								}}
								onKeyPress={onKeyPress}
								placeholder="Full Name"
								type="text"
								value={decodeURIComponent(fullName)}
							/>

							{isNotUndefined(fullName) && fullName.length > 0 ? (
								<button
									aria-label="close"
									className="close-icon close-button"
									onClick={() => {
										setFullName("");
									}}
									type="button"
								/>
							) : (
								<></>
							)}
						</div>

						<div className="input-icon-container main-search-input">
							<span className="icon icon-title" />

							<input
								className="input-with-icon contact-search-input"
								maxLength={maxJobTitleLength}
								onChange={(ch) => {
									setJobTitle(decodeURIComponent(ch.target.value));
								}}
								onKeyPress={onKeyPress}
								placeholder="Job Title"
								type="text"
								value={decodeURIComponent(jobTitle)}
							/>

							{isNotUndefined(jobTitle) && jobTitle.length > 0 ? (
								<button
									aria-label="close"
									className="close-icon close-button"
									onClick={() => {
										setJobTitle("");
									}}
									type="button"
								/>
							) : (
								<></>
							)}
						</div>

						<div className="input-icon-container main-search-input">
							<span className="icon icon-business" />

							<input
								className="input-with-icon contact-search-input"
								maxLength={maxCompanyNameLength}
								onChange={(ch) => {
									setSearchInput(decodeURIComponent(ch.target.value));
								}}
								onKeyPress={onKeyPress}
								placeholder="Company"
								ref={focusReference}
								type="text"
								value={decodeURIComponent(searchInput)}
							/>

							{isNotUndefined(searchInput) && searchInput.length > 0 ? (
								<button
									aria-label="close"
									className="close-icon close-button"
									onClick={() => {
										setSearchInput("");
									}}
									type="button"
								/>
							) : (
								<></>
							)}
						</div>

						<button
							className="search-btn submit-btn"
							onClick={() => {
								// updateSubmitSearchValues();
								onSearch();
								trackSearchEvents(activeTab, jobTitle);
							}}
							type="button"
						>
							Search
						</button>
					</div>
				</div>
			</div>
			<Loader
				inProgress={(!scrollToSearchResultsContainer && loadingState)}
			/>
			<div className="contentWrapper">
				{contactSearchDataServletResponse && (
					<div ref={searchResultsContainerReference}>
						<Breadcrumb
							breadcrumbs={breadcrumbs}
							forComponent="SearchResult"
							delimiter="/"
							styling={isSiteSearchResultsPage ? "text-capitalize font-style-medium" : ""}
						/>
						<SearchResult
							resultData={contactSearchDataServletResponse}
							paginationComponent={renderPagination()}
							forComponent="contactDirectory"
							inputSearchCombineString={inputSearchCombineString}
							tableClass="searchDataTable"
						/>
					</div>
				)}
				<Loader inProgress={loadingState && scrollToSearchResultsContainer} />
			</div>
		</>
	);
};

export default TabContactSearch;
